import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Configuración de tu proyecto Proveedor-Empresarial
const firebaseConfig = {
  apiKey: "AIzaSyD5UzkHIUkLTPXnp-RNOC-iym3BNUrX2SU",
  authDomain: "proveedor-empresarial.firebaseapp.com",
  projectId: "proveedor-empresarial",
  storageBucket: "proveedor-empresarial.firebasestorage.app",
  messagingSenderId: "513102530473",
  appId: "1:513102530473:web:fe66cdab1054ab460f26b8",
  measurementId: "G-WZ6337S1T8"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();

